module.exports = __webpack_public_path__ + "img/register-logo.09c87705.png";